const actions = {
  SET_STATE: 'social/SET_STATE',
  GET_SOCIAL_POSTS: 'social/GET_SOCIAL_POSTS',
  APPROVE_SOCIAL_POST: 'social/APPROVE_SOCIAL_POST',
}

export default actions
